import HelpButton from "../components/HelpButton";

import { StoreState } from "../../common/types/index";
import { connect } from "react-redux";

export function mapStateToProps({ query }: StoreState.All) {
  const reportLookup: {[key:string]: string} = {
    CBS: "CB",
    CBF: "CB",
    SIS: "SI",
    SIF: "SI",
  };
  return {
    selectedReport: reportLookup[query.filters.selectedReport],
  };
}

export default connect(mapStateToProps)(HelpButton);
